/**
 * Error thrown when a merchant integration error occurs.
 */
export class MerchantIntegrationError extends Error {
  constructor({message}: {message?: string}) {
    super(message);
    this.name = 'MerchantIntegrationError';
    Object.setPrototypeOf(this, MerchantIntegrationError.prototype);
  }
}
